import { render, staticRenderFns } from "./userRealName.vue?vue&type=template&id=32b55400&scoped=true"
import script from "./userRealName.vue?vue&type=script&lang=js"
export * from "./userRealName.vue?vue&type=script&lang=js"
import style0 from "./userRealName.vue?vue&type=style&index=0&id=32b55400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b55400",
  null
  
)

export default component.exports